module.exports = __webpack_public_path__ + "img/vertical_3_5_5.a6761265.png";